"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var request_exports = {};
__export(request_exports, {
  SM_APP_PARAM_NAME: () => SM_APP_PARAM_NAME,
  SM_SDK_PARAM_NAME: () => SM_SDK_PARAM_NAME,
  addQueryParamsToUrl: () => addQueryParamsToUrl,
  addSDKInfoToRequestUrl: () => addSDKInfoToRequestUrl,
  getSmSDKVersion: () => getSmSDKVersion,
  request: () => request
});
module.exports = __toCommonJS(request_exports);
async function request(apiKey, url, path) {
  let method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "POST";
  let payload = arguments.length > 4 ? arguments[4] : undefined;
  let params = arguments.length > 5 ? arguments[5] : undefined;
  let contentType = arguments.length > 6 ? arguments[6] : undefined;
  const requestOptions = {
    method,
    headers: _objectSpread(_objectSpread({}, contentType ? {
      "Content-Type": contentType
    } : {}), {}, {
      Authorization: `Bearer ${apiKey}`
    }),
    body: payload
  };
  const parsedUrl = new URL(path, url);
  let fullUrl = addSDKInfoToRequestUrl(parsedUrl.href);
  if (params) {
    fullUrl = addQueryParamsToUrl(fullUrl, params);
  }
  const response = await fetch(fullUrl, requestOptions);
  if (!response.ok) {
    throw new Error(`SMjs error: ${response.statusText} ${response.status} ${await response.text()}`);
  }
  const isPlain = contentType === "text/plain";
  let result;
  try {
    if (isPlain) {
      result = await response.text();
    } else {
      result = await response.json();
    }
  } catch (error) {
    throw new Error(`SMjs error, can't parse json: ${error}`);
  }
  return result;
}
const SM_SDK_PARAM_NAME = "sm-sdk";
const SM_APP_PARAM_NAME = "sm-app";
function getSmSDKVersion() {
  return `js-${"3.1.7"}`;
}
function addQueryParamsToUrl(url, queryParams) {
  const parsedUrl = new URL(url);
  const params = new URLSearchParams(parsedUrl.search);
  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key];
    if (value !== void 0) params.append(key, `${value}`);
  });
  parsedUrl.search = params.toString();
  return parsedUrl.href;
}
function addSDKInfoToRequestUrl(url) {
  return addQueryParamsToUrl(url, {
    [SM_SDK_PARAM_NAME]: getSmSDKVersion()
  });
}